<template>
  <q-toolbar class="bg-black">
    <!-- ===== LOGO ======================================================== -->

    <q-toolbar-title shrink>
      <span class="druk cursor-pointer" @click="$router.push('/')">
        JU IT
      </span>
    </q-toolbar-title>

    <!-- ===== NAVIGATION ================================================== -->

    <q-item
      v-for="(item, j) in navigationData()"
      :key="j"
      :to="item.to"
      :active="false"
      class="gt-sm"
    >
      <q-item-section side>
        <q-icon size="sm" :name="item.icon" color="white" />
      </q-item-section>
      <q-item-section class="text-uppercase">
        <q-item-label>{{ item.label }}</q-item-label>
      </q-item-section>
    </q-item>

    <q-space />

    <!-- ===== SETTINGS ==================================================== -->

    <!-- on dev highlight the screen width -->
    <q-badge
      v-if="env.DEV"
      class="text-uppercase"
      :label="
        screen.xs ? `xs ${screen.width}` :
        screen.sm ? `sm ${screen.width}` :
        screen.md ? `md ${screen.width}` :
        screen.lg ? `lg ${screen.width}` :
        screen.xl ? `xl ${screen.width}` :
        screen.width
      "
    />

    <!-- dark/light mode selector only appears on greater-than-small devices -->
    <z-btn
      flat
      :icon="dark.isActive ? icons.dark.off : icons.dark.on"
      class="gt-sm"
      @click="dark.toggle"
    />

    <!-- language switcher only appears on greater-than-small devices -->
    <z-btn
      flat
      class="gt-sm"
      :icon="icons.language"
      :tooltip="nextLanguage"
      @click="switchLanguage()"
    />

    <!-- logout only appears on greater-than-small devices -->
    <z-btn
      flat
      class="gt-sm q-pr-none"
      :label="user?.given_name"
      :icon-right="icons.logout"
      @click="emit('requestLogout')"
    />

    <!-- ===== SIDE MENU =================================================== -->
    <!-- appears only on smaller-than-medium devices -->

    <z-btn
      flat
      class="lt-md q-pr-none"
      :icon="icons.menu"
      @click="emit('toggleMenu')"
    />

    <!-- ===== LOADING ===================================================== -->

    <div v-if="loading" style="position: absolute; bottom: 0px; left: 0px; right: 0px;">
      <q-linear-progress indeterminate />
    </div>
  </q-toolbar>
</template>

<script setup lang="ts">
import { useTranslator } from '@juit/vue-i18n'
import { useLoader } from '@juit/vue-z'
import { useQuasar } from 'quasar'
import { computed } from 'vue'

import { icons } from '@/assets/icons'
import { user } from '@/init/client'
import { env } from '@/init/env'
import { navigationData } from '@/init/router'

const { dark, screen } = useQuasar()
const translator = useTranslator()

const { loading } = useLoader()

/* ===== EMITS ============================================================== */

const emit = defineEmits<{
  (emit: 'toggleMenu'): void
  (emit: 'requestLogout'): void
}>()

/* ===== STATE ============================================================== */

const nextLanguage = computed(() => {
  if (translator.language === 'de') {
    return new Intl.DisplayNames('en-GB', { type: 'language' }).of('en')
  } else {
    return new Intl.DisplayNames('de-DE', { type: 'language' }).of('de')
  }
})

/* ===== ACTIONS ============================================================ */

function switchLanguage(): void {
  if (translator.language === 'de') {
    translator.locale = new Intl.Locale('en-GB')
  } else {
    translator.locale = new Intl.Locale('de-DE')
  }
}
</script>
